import {TYPE_SET_CHATS} from "app/redux/chats&notifications/chatsTypes";

export const actionSetChats = (chats, pagedData) => ({
  type: TYPE_SET_CHATS,
  payload: {
    chats,
    pagedData,
  },
});
